import React from 'react'
import { Icon, IconProps } from '@chakra-ui/react'

export const HeartOutlineIcon = (props: IconProps) => {
  return (
    <Icon viewBox='0 0 100 100' {...props}>
      <path d='M50,86.22l29.19-29.19c9.25-9.25,12.8-19.87,9.72-29.12c-2.47-7.43-8.84-12.76-16.62-13.89c-8.12-1.18-16.1,2.33-22.3,9.72  c-6.19-7.38-14.17-10.9-22.3-9.72c-7.79,1.13-14.16,6.46-16.62,13.89c-3.07,9.26,0.47,19.87,9.72,29.12L50,86.22z M15.82,29.47  c1.87-5.63,6.7-9.66,12.6-10.52c0.78-0.11,1.55-0.17,2.33-0.17c6.32,0,12.48,3.72,17.2,10.48L50,32.19l2.04-2.93  c5.3-7.59,12.42-11.34,19.53-10.31c5.91,0.86,10.74,4.89,12.6,10.52c2.46,7.4-0.65,16.16-8.52,24.02L50,79.16L24.33,53.5  C16.47,45.63,13.36,36.87,15.82,29.47z'></path>
    </Icon>
  )
}
